module.exports = __webpack_public_path__ + "static/media/circle-green.e1a79be8.svg";